// What the progress line says while a stage runs. Modelled on
// taraFeedbackProgressCopy.js: keyed off elapsed time rather than server
// events, for the same reason -- the API reports a phase only when polled.
//
// Neither LNAT stage carries TARA's "first student on this question builds
// the shared reference" cost (there is no live-generation fallback; the
// archetype is imported ahead of time), so neither step list runs as long as
// TARA's diagnostic does.

const STEPS = {
  reasoning_trace: [
    [0, 'Reading your essay…'],
    [8000, 'Mapping your reasoning onto the question’s argument structure…'],
    [20000, 'Scoring each dimension with evidence from your essay…'],
    [45000, 'Nearly there, this one is taking a little longer than usual.'],
    [90000, 'Still working. You can leave this page, your work is saved, and '
          + 'the result will be here when you come back.'],
  ],
  examiner_report: [
    [0, 'Pulling together your reasoning trace and your score…'],
    [8000, 'Writing your examiner report…'],
    [25000, 'Nearly there.'],
  ],
};

export function lnatFeedbackProgressCopy(stage, elapsedMs = 0) {
  const steps = STEPS[stage] || STEPS.reasoning_trace;
  let text = steps[0][1];
  steps.forEach(([at, copy]) => {
    if (elapsedMs >= at) text = copy;
  });
  return text;
}
